<template>
  <svg v-if="awardedDeviceIds.includes(deviceId)" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
    viewBox="0 0 12 12">
    <circle r="5" transform="matrix(1 0 0 1 6 6)" :fill="iconColor" fill-rule="evenodd" stroke="#37474f"
      stroke-width="1.5" />
    <circle r="2" transform="matrix(1 0 0 1 6 6)" :fill="deviceColor" fill-rule="evenodd" stroke="#37474f"
      stroke-width="1" />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 12">
    <circle r="5" transform="matrix(1 0 0 1 6 6)" :fill="iconColor" fill-rule="evenodd" stroke="#37474f"
      stroke-width="1.5" />
    <circle r="2" transform="matrix(1 0 0 1 6 6)" :fill="deviceColor" fill-rule="evenodd" stroke="#37474f"
      stroke-width="1" />
  </svg>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    deviceColor: {
      type: String,
      default: '#37474F'
    },
    deviceId: {
      type: Number,
      required: true
    },
    iconActive: {
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters([
      'awardedDeviceIds',
      'positions'
    ]),
    timeSince() {
      return moment().diff(moment(this.positions[this.deviceId].fixTime), 'minutes')
    },
    iconColor() {
      if (!this.iconActive) {
        return '#a0b1b9' // grey
      } else if (this.timeSince > 30) {
        return '#f99b62' // yellow-orange
      } else if (this.awardedDeviceIds.includes(this.deviceId)) {
        return '#FF3C01' // red
      } else {
        return '#ffffff' // white
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
